"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3409],{

/***/ 63409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p0": function() { return /* reexport */ account; },
  "AZ": function() { return /* reexport */ checkout/* default */.Z; },
  "HQ": function() { return /* reexport */ layouts_default/* default */.Z; },
  "Zn": function() { return /* reexport */ main; },
  "Uz": function() { return /* reexport */ private_auth; },
  "y2": function() { return /* reexport */ standalone; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/toggled/dist/toggled.esm.js
var toggled_esm = __webpack_require__(67866);
// EXTERNAL MODULE: ./src/components/index.ts + 136 modules
var components = __webpack_require__(13823);
// EXTERNAL MODULE: ./src/analytics/index.ts + 4 modules
var analytics = __webpack_require__(30588);
// EXTERNAL MODULE: ./src/truck/icon/index.tsx + 1 modules
var icon = __webpack_require__(63216);
// EXTERNAL MODULE: ./src/utils/index.ts + 24 modules
var utils = __webpack_require__(90644);
;// CONCATENATED MODULE: ./src/components/contact/index.tsx





var ContactType;
(function(ContactType) {
    ContactType["MAIL"] = "mail";
    ContactType["WHATSAPP"] = "whatsapp";
    ContactType["TELEPHONE"] = "telephone";
    ContactType["YOUTUBE"] = "youtube";
    ContactType["INSTAGRAM"] = "instagram";
    ContactType["FACEBOOK"] = "facebook";
})(ContactType || (ContactType = {}));
var Contact = function(props) {
    var vendor = props.vendor;
    var facebook = vendor.facebook, instagram = vendor.instagram, youtube = vendor.youtube;
    var hasSocialNetwork = facebook || instagram || youtube;
    var socialMediaTypes = [
        ContactType.FACEBOOK,
        ContactType.INSTAGRAM,
        ContactType.YOUTUBE
    ];
    var onContactClick = function(type) {
        if (socialMediaTypes.includes(type)) {
            analytics/* analytics.socialMedia */.co.socialMedia(type);
        } else {
            analytics/* analytics.contact */.co.contact(type);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "font-semibold",
                        children: "Contacto"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            vendor.contactEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                type: "mail",
                                className: "break-words",
                                href: (0,utils/* emailUrl */.u4)(vendor.contactEmail),
                                rel: "nofollow",
                                onClick: function() {
                                    return onContactClick(ContactType.MAIL);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: vendor.contactEmail
                                })
                            }),
                            vendor.phone && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                type: "telephone",
                                className: "flex gap-2 break-words",
                                href: (0,utils/* phoneUrl */.hd)(vendor.phone),
                                rel: "nofollow",
                                onClick: function() {
                                    return onContactClick(ContactType.TELEPHONE);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        type: "telephone",
                                        color: "black"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xl font-semibold",
                                        children: vendor.phone
                                    })
                                ]
                            }),
                            vendor.whatsapp && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                type: "whatsapp",
                                className: "flex gap-2 break-words",
                                href: (0,utils/* whatsappUrl */.Ah)(vendor.phone),
                                rel: "noopener noreferrer nofollow",
                                target: "_blank",
                                onClick: function() {
                                    return onContactClick(ContactType.WHATSAPP);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        type: "whatsapp",
                                        color: "black"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xl font-semibold",
                                        children: vendor.whatsapp
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            hasSocialNetwork && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "S\xedguenos en:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            facebook && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: facebook,
                                type: "facebook",
                                rel: "noopener noreferrer nofollow",
                                target: "_blank",
                                onClick: function() {
                                    return onContactClick(ContactType.FACEBOOK);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    type: "facebook",
                                    color: "black"
                                })
                            }),
                            instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: instagram,
                                type: "instagram",
                                rel: "noopener noreferrer nofollow",
                                target: "_blank",
                                onClick: function() {
                                    return onContactClick(ContactType.INSTAGRAM);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    type: "instagram",
                                    color: "black"
                                })
                            }),
                            youtube && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: youtube,
                                type: "youtube",
                                rel: "noopener noreferrer nofollow",
                                target: "_blank",
                                onClick: function() {
                                    return onContactClick(ContactType.YOUTUBE);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    type: "youtube",
                                    color: "black"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var contact = (/*#__PURE__*/react.memo(Contact));

// EXTERNAL MODULE: ./src/components/main-header/index.tsx + 66 modules
var main_header = __webpack_require__(18343);
// EXTERNAL MODULE: ./src/components/media/index.ts
var media = __webpack_require__(43902);
// EXTERNAL MODULE: ./src/gql/queries/index.ts + 45 modules
var queries = __webpack_require__(98);
// EXTERNAL MODULE: ./src/hooks/use-vendor.ts
var use_vendor = __webpack_require__(1360);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
// EXTERNAL MODULE: ./src/truck/utils/index.ts + 8 modules
var truck_utils = __webpack_require__(14250);
// EXTERNAL MODULE: ./src/variables.js
var variables = __webpack_require__(93063);
// EXTERNAL MODULE: ./src/layouts/elements.js
var layouts_elements = __webpack_require__(51924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/truck/anchor/index.ts
var truck_anchor = __webpack_require__(75689);
;// CONCATENATED MODULE: ./src/layouts/account/collapsible-menu-item/index.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  flex-direction: column;\n  padding-left: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bbf27ac6-0"
})(_templateObject());
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bbf27ac6-1"
})(_templateObject1(), function(props) {
    return props.$isOpen ? "flex" : "none";
}, function(props) {
    return props.theme.spacing.cozy * 4;
});
var StyledAnchor = (0,styled_components_browser_esm/* default */.ZP)(truck_anchor/* default */.Z).withConfig({
    componentId: "sc-bbf27ac6-2"
})(_templateObject2(), function(props) {
    return props.theme.dimensions.buttonHeight;
});
var CollapsibleMenuAnchor = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var selected = props.selected, rest = (0,_object_without_properties/* default */.Z)(props, [
        "selected"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnchor, (0,_object_spread/* default */.Z)({
        ref: ref,
        $color: selected ? "primary" : "black"
    }, rest));
});
function CollapsibleMenuItem(props) {
    var title = props.title, iconType = props.iconType, children = props.children, className = props.className, style = props.style;
    var router = (0,next_router.useRouter)();
    var selected = react.useMemo(function() {
        var arr = react.Children.toArray(children);
        return arr.some(function(child) {
            return child.props.href === router.asPath;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.asPath
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(selected), 2), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        className: className,
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx/* default */.Z)("flex h-12 items-center gap-2", selected && "font-semibold text-brand-primary"),
                onClick: function() {
                    return setIsOpen(function(v) {
                        return !v;
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        type: iconType,
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        className: "ml-auto",
                        type: isOpen ? "caret-up" : "caret-down",
                        color: "currentColor",
                        size: "sm"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContent, {
                $isOpen: isOpen,
                children: children
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/layouts/account/menu-item/index.tsx




/* harmony default export */ var menu_item = (/*#__PURE__*/react.forwardRef(function MenuItem(props, ref) {
    var iconType = props.iconType, children = props.children, selected = props.selected, onClick = props.onClick, href = props.href;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: (0,clsx/* default */.Z)("flex h-12 items-center gap-2", selected && "font-semibold text-brand-primary"),
        onClick: onClick,
        href: href,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                type: iconType,
                color: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    });
}));

;// CONCATENATED MODULE: ./src/layouts/account/menu/index.tsx








function Menu(props) {
    var user = props.user, style = props.style, className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: className,
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RouterLink */.rH, {
                href: "/mi-cuenta",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item, {
                    iconType: "profile",
                    children: "Mi cuenta"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RouterLink */.rH, {
                href: "/mi-cuenta/cambiar-contrasena",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item, {
                    iconType: "lock",
                    children: "Cambiar contrase\xf1a"
                })
            }),
            (user === null || user === void 0 ? void 0 : user.lineOfCredit) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RouterLink */.rH, {
                href: "/mi-cuenta/linea-de-credito",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item, {
                    iconType: "card",
                    children: "L\xednea de cr\xe9dito"
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RouterLink */.rH, {
                href: "/mi-cuenta/pedidos",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item, {
                    iconType: "order",
                    children: "Mis pedidos"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(toggled_esm/* Flag */.WN, {
                flagQuery: constants/* flags.PRICE_QUOTATION_NAVIGATION */.id.PRICE_QUOTATION_NAVIGATION,
                children: user.isLoggedIn && user.quotationsPermission && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RouterLink */.rH, {
                    href: "/mi-cuenta/cotizaciones",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item, {
                        iconType: "document",
                        children: "Mis cotizaciones"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(toggled_esm/* Flag */.WN, {
                flagQuery: constants/* flags.ALLOW_REPURCHASE */.id.ALLOW_REPURCHASE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollapsibleMenuItem, {
                    title: "Comprar de nuevo",
                    iconType: "update",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RouterLink */.rH, {
                            href: "/mi-cuenta/mas-comprados",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleMenuAnchor, {
                                children: "Productos m\xe1s comprados"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RouterLink */.rH, {
                            href: "/mi-cuenta/ultimo-pedido",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleMenuAnchor, {
                                children: "Mi \xfaltimo pedido"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item, {
                iconType: "logout",
                onClick: utils/* logout */.kS,
                children: "Cerrar sesi\xf3n"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/layouts/account/elements.js

function elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        "px;\n\n  ",
        " {\n    column-gap: ",
        "px;\n    flex-direction: row;\n    min-height: 0;\n  }\n"
    ]);
    elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  min-height: ",
        ";\n  padding: 0 ",
        "px;\n  width: ",
        "px;\n\n  > :first-child {\n    border-bottom: 1px solid ",
        ";\n    padding-bottom: ",
        "px;\n  }\n\n  > :last-child {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function elements_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n    }\n  "
    ]);
    elements_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: ",
        "px;\n\n  ",
        "\n\n  ",
        " {\n    max-width: ",
        "px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  margin: ",
        "px 0;\n  padding: 0 ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var spacing = truck_utils/* themeGetters.spacing */.$z.spacing, colors = truck_utils/* themeGetters.colors */.$z.colors;
var Container = (0,styled_components_browser_esm/* default */.ZP)(layouts_elements/* LayoutContent */.b).withConfig({
    componentId: "sc-d8edbe86-0"
})(elements_templateObject(), theme/* default.spacing.cozy */.Z.spacing.cozy * 128, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.comfortable */.Z.spacing.comfortable);
var Sidebar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d8edbe86-1"
})(elements_templateObject1(), colors("white"), variables/* viewportHeights.getDefaultLayout */.dC.getDefaultLayout, spacing("comfortable"), theme/* default.spacing.cozy */.Z.spacing.cozy * 40, colors("gray"), spacing("comfortable"), spacing("comfortable"));
var getPadding = function(props) {
    var noPadding = props.noPadding;
    if (noPadding) {
        return 0;
    }
    return spacing("comfortable");
};
var getHeightStyle = function(props) {
    var fullHeight = props.fullHeight;
    var height = variables/* viewportHeights.getDefaultLayout */.dC.getDefaultLayout(props);
    if (!fullHeight) {
        return "\n      min-height: ".concat(height, ";\n    ");
    }
    return (0,styled_components_browser_esm/* css */.iv)(elements_templateObject2(), height, (0,styled_breakpoints.up)("lg"), height);
};
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d8edbe86-2"
})(_templateObject3(), colors("white"), getPadding, getHeightStyle, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.comfortable */.Z.spacing.comfortable * 43);
var StyledMenu = (0,styled_components_browser_esm/* default */.ZP)(Menu).withConfig({
    componentId: "sc-d8edbe86-3"
})(_templateObject4(), colors("white"), spacing("comfortable"), spacing("comfortable"));

;// CONCATENATED MODULE: ./src/layouts/account/index.js















var getChildren = function(props) {
    var children = props.children, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    if (!(0,lodash.isFunction)(children)) {
        return children;
    }
    return children(restProps);
};
var AccountLayout = function(props) {
    var children = props.children, _noPadding = props.noPadding, noPadding = _noPadding === void 0 ? false : _noPadding, _fullHeight = props.fullHeight, fullHeight = _fullHeight === void 0 ? false : _fullHeight, _includesCart = props.includesCart, includesCart = _includesCart === void 0 ? false : _includesCart;
    var vendor = (0,use_vendor/* default */.Z)();
    var hasLineOfCredit = (0,toggled_esm/* useFlag */.P5)(constants/* flags.LINES_OF_CREDIT */.id.LINES_OF_CREDIT);
    // FIXME: use default `fetchPolicy` no matter anything
    var userResponse = (0,react_hooks_esm/* useQuery */.aM)(queries/* userQuery */.v0, {
        fetchPolicy: includesCart ? "network-only" : "cache-first",
        variables: {
            includesCart: includesCart,
            includesLineOfCredit: hasLineOfCredit
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(main_header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: userResponse.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Loader */.nt, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* default */.Z, {
                            mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenu, {
                                user: userResponse.data.user
                            }),
                            desktop: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Sidebar, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
                                        user: userResponse.data.user
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contact, {
                                        vendor: vendor
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                            noPadding: noPadding,
                            fullHeight: fullHeight,
                            children: getChildren({
                                children: children,
                                user: userResponse.data.user
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var account = (AccountLayout);

// EXTERNAL MODULE: ./src/layouts/checkout/index.js + 18 modules
var checkout = __webpack_require__(70157);
// EXTERNAL MODULE: ./src/layouts/default/index.js + 1 modules
var layouts_default = __webpack_require__(48305);
// EXTERNAL MODULE: ./src/hooks/index.ts + 30 modules
var hooks = __webpack_require__(91497);
// EXTERNAL MODULE: ./src/hooks/use-cart-animation.ts
var use_cart_animation = __webpack_require__(11080);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/truck/new-button/NewButton.tsx + 4 modules
var NewButton = __webpack_require__(8262);
;// CONCATENATED MODULE: ./src/modules/shopping-cart/containers/open-cart-button-floating/OpenCartButtonFloating.style.ts

function OpenCartButtonFloating_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    left: calc(100% - ",
        "px);\n  "
    ]);
    OpenCartButtonFloating_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OpenCartButtonFloating_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  66% {transform: scale(1.1);}\n  90% {transform: scale(0.95);}\n"
    ]);
    OpenCartButtonFloating_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OpenCartButtonFloating_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 0.4s ease-in-out;\n    "
    ]);
    OpenCartButtonFloating_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OpenCartButtonFloating_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: ",
        "px;\n  left: ",
        "px;\n  position: fixed;\n  transition: left 0.25s ease-in-out;\n  width: unset;\n  z-index: ",
        ";\n\n  ",
        "\n\n  > button {\n    padding: 0 ",
        "px;\n  }\n\n  ",
        "}\n"
    ]);
    OpenCartButtonFloating_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var getCalculatedLeft = function(props) {
    var alignRight = props.alignRight, clientWidth = props.clientWidth;
    if (!alignRight) {
        return "";
    }
    return (0,styled_components_browser_esm/* css */.iv)(OpenCartButtonFloating_style_templateObject(), theme/* default.spacing.comfortable */.Z.spacing.comfortable + clientWidth);
};
var popInAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(OpenCartButtonFloating_style_templateObject1());
var OpenCartButtonFloating_style_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-216a4274-0"
})(OpenCartButtonFloating_style_templateObject3(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.comfortable */.Z.spacing.comfortable, variables/* stack.cartButton */.kn.cartButton, getCalculatedLeft, theme/* default.spacing.comfortable */.Z.spacing.comfortable, function(param) {
    var triggerAnimation = param.triggerAnimation;
    return triggerAnimation && (0,styled_components_browser_esm/* css */.iv)(OpenCartButtonFloating_style_templateObject2(), popInAnimation);
});

;// CONCATENATED MODULE: ./src/modules/shopping-cart/containers/open-cart-button-floating/OpenCartButtonFloating.view.tsx






var OpenCartButtonFloatingView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var lineItemsTotalQuantity = props.lineItemsTotalQuantity, triggerAnimation = props.triggerAnimation, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart, alignRight = props.alignRight, clientWidth = props.clientWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/carrito",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenCartButtonFloating_style_Container, {
            ref: ref,
            alignRight: alignRight,
            clientWidth: clientWidth,
            triggerAnimation: triggerAnimation,
            onAnimationStart: onAnimationStart,
            onAnimationEnd: onAnimationEnd,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewButton/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        type: "cart",
                        color: "currentColor"
                    }),
                    " ",
                    lineItemsTotalQuantity
                ]
            })
        })
    });
});

;// CONCATENATED MODULE: ./src/modules/shopping-cart/containers/open-cart-button-floating/OpenCartButtonFloating.tsx





var getOffset = function(el) {
    var bounds = el.getBoundingClientRect();
    return {
        top: bounds.top + document.body.scrollTop,
        bottom: bounds.top + el.clientHeight
    };
};
var OpenCartButtonFloating = function() {
    var ref;
    var buttonRef = (0,react.useRef)(null);
    var footerRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), alignRight = ref1[0], setAlignRight = ref1[1];
    var lineItemsTotalQuantity = (0,hooks/* useCartTotalQuantity */.Dx)();
    (0,react.useEffect)(function() {
        footerRef.current = document.body.querySelector("footer");
        var watchOverlappingWithFooter = function() {
            if (!buttonRef.current || !footerRef.current) {
                return;
            }
            var buttonOffset = getOffset(buttonRef.current);
            var footerOffset = getOffset(footerRef.current);
            setAlignRight(buttonOffset.bottom >= footerOffset.top);
        };
        window.addEventListener("scroll", watchOverlappingWithFooter);
        return function() {
            window.removeEventListener("scroll", watchOverlappingWithFooter);
        };
    }, [
        buttonRef
    ]);
    var ref2 = (0,use_cart_animation/* default */.Z)(lineItemsTotalQuantity), triggerAnimation = ref2.triggerAnimation, setTriggerAnimation = ref2.setTriggerAnimation, setAnimationPlaying = ref2.setAnimationPlaying;
    var handleOnAnimationStart = function() {
        setAnimationPlaying(true);
    };
    var handleOnAnimationEnd = function() {
        setTriggerAnimation(false);
        setAnimationPlaying(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenCartButtonFloatingView, {
        ref: buttonRef,
        lineItemsTotalQuantity: lineItemsTotalQuantity,
        triggerAnimation: triggerAnimation,
        onAnimationStart: handleOnAnimationStart,
        onAnimationEnd: handleOnAnimationEnd,
        alignRight: alignRight,
        clientWidth: (ref = buttonRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth
    });
};

// EXTERNAL MODULE: ./src/modules/shopping-cart/containers/cart/Cart.tsx + 37 modules
var Cart = __webpack_require__(3790);
// EXTERNAL MODULE: ./src/truck/image/index.tsx
var truck_image = __webpack_require__(52679);
// EXTERNAL MODULE: ./src/utils/cloudinary.ts
var cloudinary = __webpack_require__(61761);
// EXTERNAL MODULE: ./src/utils/urls.ts
var urls = __webpack_require__(996);
;// CONCATENATED MODULE: ./src/layouts/main/footer/index.tsx
















function footer_Contact() {
    var vendor = (0,use_vendor/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "text-xl font-semibold",
                children: "Contacto"
            }),
            vendor.fiscalName && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm",
                children: vendor.fiscalName
            }),
            vendor.fiscalAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm",
                children: vendor.fiscalAddress
            }),
            vendor.contactEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "text-sm",
                href: (0,urls/* emailUrl */.u4)(vendor.contactEmail),
                onClick: function() {
                    return analytics/* analytics.contact */.co.contact("mail");
                },
                rel: "nofollow",
                children: vendor.contactEmail
            }),
            vendor.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "text-xl font-semibold",
                href: (0,urls/* phoneUrl */.hd)(vendor.phone),
                onClick: function() {
                    return analytics/* analytics.contact */.co.contact("telephone");
                },
                rel: "nofollow",
                children: vendor.phone
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-2 leading-none",
                children: [
                    vendor.facebook && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: vendor.facebook,
                        target: "_blank",
                        rel: "noopener noreferrer nofollow",
                        onClick: function() {
                            return analytics/* analytics.socialMedia */.co.socialMedia("facebook");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                            type: "facebook",
                            interactive: false,
                            color: "currentColor"
                        })
                    }),
                    vendor.whatsappUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: vendor.whatsappUrl,
                        target: "_blank",
                        rel: "noopener noreferrer nofollow",
                        onClick: function() {
                            return analytics/* analytics.contact */.co.contact("whatsapp");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                            type: "whatsapp",
                            interactive: false,
                            color: "currentColor"
                        })
                    }),
                    vendor.instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: vendor.instagram,
                        target: "_blank",
                        rel: "noopener noreferrer nofollow",
                        onClick: function() {
                            return analytics/* analytics.socialMedia */.co.socialMedia("instagram");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                            type: "instagram",
                            interactive: false,
                            color: "currentColor"
                        })
                    }),
                    vendor.youtube && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: vendor.youtube,
                        target: "_blank",
                        rel: "noopener noreferrer nofollow",
                        onClick: function() {
                            return analytics/* analytics.socialMedia */.co.socialMedia("youtube");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                            type: "youtube",
                            interactive: false,
                            color: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}
function About() {
    var ref;
    var vendor = (0,use_vendor/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "text-xl font-semibold",
                children: "Acerca de"
            }),
            (0,lodash.map)((ref = vendor.settings) === null || ref === void 0 ? void 0 : ref.storefrontLinks, function(link) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "text-sm",
                    href: link.url,
                    target: "_blank",
                    rel: "noopener noreferrer nofollow",
                    children: link.label
                }, link.label);
            })
        ]
    });
}
function PaymentMethods() {
    var ref;
    var data = (0,react_hooks_esm/* useQuery */.aM)(queries/* paymentMethodsImageQuery */.j0).data;
    var hasCustomerComplaints = (0,toggled_esm/* useFlag */.P5)(constants/* flags.CUSTOMER_COMPLAINTS */.id.CUSTOMER_COMPLAINTS);
    var paymentMethods = (0,lodash.uniqBy)(data === null || data === void 0 ? void 0 : (ref = data.vendor) === null || ref === void 0 ? void 0 : ref.paymentMethods, "image");
    var dataSource = (0,lodash.filter)(paymentMethods, function(paymentMethod) {
        return !!paymentMethod.image;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            !(0,lodash.isEmpty)(dataSource) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "text-xl font-semibold",
                        children: "Medios de Pago"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-wrap gap-2",
                        children: (0,lodash.map)(dataSource, function(paymentMethod) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_image/* default */.Z, {
                                height: "auto",
                                width: "auto",
                                alt: "payment cards",
                                src: cloudinary/* default.applyTransformations */.Z.applyTransformations(paymentMethod.image)
                            }, paymentMethod.image);
                        })
                    })
                ]
            }),
            hasCustomerComplaints && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CustomerComplaints */.ih, {
                className: "lg:self-left mt-6 self-end"
            })
        ]
    });
}
function PoweredBy() {
    var vendor = (0,use_vendor/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-center gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Powered by"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "flex items-center",
                href: "https://riqra.com/?utm_source=tiendas&utm_medium=footer&utm_campaign=referido_tiendas&utm_term=".concat(vendor.manufacturer.name),
                target: "_blank",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_image/* default */.Z, {
                    src: theme/* default.branding.logotypeWhite */.Z.branding.logotypeWhite,
                    height: theme/* default.spacing.relaxed */.Z.spacing.relaxed
                })
            })
        ]
    });
}
function Footer(param) {
    var className = param.className;
    var hasHidePoweredByRiqraFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.HIDE_POWERED_BY_RIQRA */.id.HIDE_POWERED_BY_RIQRA);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (0,clsx/* default */.Z)("flex flex-col justify-between gap-12 break-words bg-[#2d333c] p-8 pb-4 text-white lg:min-h-80", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid gap-8 lg:grid-cols-3 lg:gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_Contact, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(About, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethods, {})
                ]
            }),
            !hasHidePoweredByRiqraFF && /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweredBy, {})
        ]
    });
}
/* harmony default export */ var footer = (Footer);

;// CONCATENATED MODULE: ./src/layouts/main/elements.ts

function main_elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n\n  ",
        " {\n    margin: 0;\n    width: ",
        ";\n  }\n"
    ]);
    main_elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function main_elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: 0;\n  position: fixed;\n  right: 0;\n  width: ",
        "px;\n"
    ]);
    main_elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function main_elements_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        "px;\n\n  ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    main_elements_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var elements_StyledContent = (0,styled_components_browser_esm/* default */.ZP)(layouts_elements/* LayoutContent */.b).withConfig({
    componentId: "sc-6dc021d7-0"
})(main_elements_templateObject(), (0,styled_breakpoints.up)("lg"), function(props) {
    return props.$isFullWidth ? "100%" : "calc(100% - ".concat(variables/* dimensions.cartWidth */.MB.cartWidth, "px)");
});
var StyledCart = (0,styled_components_browser_esm/* default */.ZP)(Cart/* Cart */.A).withConfig({
    componentId: "sc-6dc021d7-1"
})(main_elements_templateObject1(), variables/* dimensions.cartWidth */.MB.cartWidth);
var StyledFooter = (0,styled_components_browser_esm/* default */.ZP)(footer).withConfig({
    componentId: "sc-6dc021d7-2"
})(main_elements_templateObject2(), theme/* default.spacing.cozy */.Z.spacing.cozy * 8, (0,styled_breakpoints.up)("lg"), function(props) {
    return props.$isFullWidth ? "100%" : "calc(100% - ".concat(variables/* dimensions.cartWidth */.MB.cartWidth, "px)");
});

;// CONCATENATED MODULE: ./src/layouts/main/index.tsx







function MainLayout(param) {
    var loading = param.loading, children = param.children;
    var isFullWidth = (0,toggled_esm/* useFlag */.P5)(constants/* flagQueries.HAS_FULL_WIDTH */.mE.HAS_FULL_WIDTH);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MainHeader */.cC, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Media */.pU, {
                desktop: !isFullWidth && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCart, {}),
                mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenCartButtonFloating, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_StyledContent, {
                $isFullWidth: isFullWidth,
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Loader */.nt, {}) : children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
                $isFullWidth: isFullWidth
            })
        ]
    });
}
/* harmony default export */ var main = (MainLayout);

// EXTERNAL MODULE: ./src/components/logo/index.js + 1 modules
var logo = __webpack_require__(2372);
;// CONCATENATED MODULE: ./src/layouts/private-auth/elements.js

function private_auth_elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  width: 100%;\n\n  ",
        " {\n    height: 100vh;\n  }\n"
    ]);
    private_auth_elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function private_auth_elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  height: inherit;\n  padding: 0 ",
        "px;\n  padding-top: ",
        "px;\n  width: 100%;\n\n  ",
        " {\n    justify-content: center;\n    padding: 0 ",
        "px;\n    width: ",
        "px;\n  }\n"
    ]);
    private_auth_elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function private_auth_elements_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: default;\n  height: ",
        "px;\n  left: 50%;\n  object-fit: contain;\n  object-position: top;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: ",
        "px;\n  transform: translateX(-50%);\n  width: ",
        "px;\n\n  ",
        " {\n    left: ",
        "px;\n    text-align: start;\n    transform: unset;\n  }\n"
    ]);
    private_auth_elements_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function elements_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: url(",
        ");\n  background-position: center;\n  background-size: cover;\n  display: flex;\n  flex: 1;\n"
    ]);
    elements_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function elements_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    backdrop-filter: blur(",
        "px);\n    background: rgba(255, 255, 255, 0.2);\n    display: flex;\n    flex: 1;\n    object-fit: contain;\n  }\n"
    ]);
    elements_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var elements_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-473c1b0f-0"
})(private_auth_elements_templateObject(), (0,styled_breakpoints.up)("lg"));
var InnerContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-473c1b0f-1"
})(private_auth_elements_templateObject1(), theme/* default.colors.white */.Z.colors.white, theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.cozy */.Z.spacing.cozy * 15, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 8, theme/* default.spacing.cozy */.Z.spacing.cozy * 61);
var Logo = (0,styled_components_browser_esm/* default */.ZP)(logo/* default */.Z).withConfig({
    componentId: "sc-473c1b0f-2"
})(private_auth_elements_templateObject2(), theme/* default.spacing.cozy */.Z.spacing.cozy * 5, theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.cozy */.Z.spacing.cozy * 20, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.comfortable */.Z.spacing.comfortable);
var BannerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-473c1b0f-3"
})(elements_templateObject3(), function(props) {
    return props.src;
});
var Banner = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-473c1b0f-4"
})(elements_templateObject4(), (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 12.5);

;// CONCATENATED MODULE: ./src/layouts/private-auth/index.js







var PrivateAuthLayout = function(props) {
    var children = props.children;
    var vendor = (0,use_vendor/* default */.Z)();
    var loginBg = utils/* cloudinary.applyTransformations */.nl.applyTransformations(vendor.loginBg, constants/* transformations.PRIVATE_LOGIN_BG */.S7.PRIVATE_LOGIN_BG);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(elements_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                vendor: vendor,
                alternative: true,
                size: "large"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContainer, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContainer, {
                src: loginBg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* default */.Z, {
                    desktop: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                        src: loginBg
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var private_auth = (PrivateAuthLayout);

// EXTERNAL MODULE: ./src/layouts/standalone/elements.tsx
var standalone_elements = __webpack_require__(50360);
;// CONCATENATED MODULE: ./src/layouts/standalone/components/header.tsx

function header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  display: flex;\n  height: ",
        "px;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100%;\n"
    ]);
    header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var header_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-103d9444-0"
})(header_templateObject(), function(props) {
    return props.theme.colors.primary;
}, function(props) {
    return props.theme.spacing.cozy * 6;
});
var Header = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(standalone_elements/* CenterContainer */.H, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: constants/* riqraInfo.website */.eR.website,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: constants/* images.RIQRA_LOGOTYPE_WHITE */.Wc.RIQRA_LOGOTYPE_WHITE,
                    height: theme/* default.spacing.cozy */.Z.spacing.cozy * 4,
                    alt: "Riqra Logo"
                })
            })
        })
    });
};
/* harmony default export */ var header = (Header);

;// CONCATENATED MODULE: ./src/layouts/standalone/components/index.ts


;// CONCATENATED MODULE: ./src/layouts/standalone/index.tsx



var StandaloneLayout = function(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
            children
        ]
    });
};
/* harmony default export */ var standalone = (StandaloneLayout);

;// CONCATENATED MODULE: ./src/layouts/index.ts








/***/ }),

/***/ 50360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ CenterContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: auto;\n  margin-right: auto;\n  max-width: ",
        "px;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CenterContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6c5db55a-0"
})(_templateObject(), function(props) {
    return props.theme.spacing.cozy * 127.5;
});


/***/ })

}]);